import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';

import Utils from 'src/app/utils';

@Component({
  selector: 'app-workers-inactive',
  templateUrl: './workers-inactive.component.html',
  styleUrls: ['./workers-inactive.component.scss']
})

export class WorkersInactiveComponent implements OnInit {

  workers : any;

  view : any;
  sort = 'name';
  monitor = 'all';
  group = 'all';
  search = '';

  groups:any = [];

  u = Utils;

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, public transloco: TranslocoService) { }

  ngOnInit(): void {

    this.pagination.page = 1;
    this.getWorkers();

  }

  getWorkers(): void {
    const filter = {
      sort: this.sort,
      monitor: this.monitor,
      group: this.group,
      search: this.search,
      page: this.pagination.page
    };

    this.okService.get("workers/inactive", filter).subscribe({
      next: (data) => {
        this.workers = data.body ?? [];
        this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;
        this.groups = [{ id: 'all', name: 'All Workers' }, { id: 'none', name: 'No Group' }].concat(this.okService.groups);
      },
      error: (e) => {
        this.okService.setAlert(e, "warning");
      }
    });
  }


  changePage(){
    this.getWorkers();
  }

  updateFilter(){
    this.getWorkers();
  }

  clearFilter(){
    this.monitor = 'all';
    this.group = 'all';
    this.search = '';
    this.updateFilter();
  }

  doActivate(worker: any): void {
    this.okService.post('workers/activate/' + worker.id, []).subscribe({
      next: () => {
        this.okService.setAlert(this.transloco.translate('Your worker has been activated.'), "success");
        this.getWorkers();
      },
      error: (e) => {
        this.okService.setAlert(this.transloco.translate("You have reached your maximum number of Worker Licenses"), "warning");
        this.getWorkers();
      }
    });
  }

}
